/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Slug_Auto_HintInputs */

const cs_blog_slug_auto_hint = /** @type {(inputs: Blog_Slug_Auto_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponechte prázdné pro vygenerování z nadpisu`)
};

const en_blog_slug_auto_hint = /** @type {(inputs: Blog_Slug_Auto_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave empty to generate from title`)
};

/**
* | output |
* | --- |
* | "Leave empty to generate from title" |
*
* @param {Blog_Slug_Auto_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_slug_auto_hint = /** @type {((inputs?: Blog_Slug_Auto_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Slug_Auto_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_slug_auto_hint(inputs)
	return cs_blog_slug_auto_hint(inputs)
});